<template lang="pug">
.confirm-terminate-modal
  b-modal(ref="modal" size="lg" no-close-on-backdrop no-close-on-esc hide-header
    @ok="update" @cancel="cancel")
    .confirm-terminate-modal-body
      .confirm-title {{_residentRoom}} {{_residentName}}様の{{_familyName}}（{{_familyRelation}}）のオンライン面会の案内を転送しますか？
      .confirm
        .message 転送前に以下をご確認ください。
        ul.confirm-list
          li
            span 宛先
            strong.font-strong-color 「{{value.name}}の{{value.memberName}}」
            span が施設のスマートフォンであること。
          li 宛先のスマートフォンですぐに案内を確認してください。
        label
          input(type="checkbox" @click="checked = !checked")
          span 確認しました

    div(slot="modal-footer" slot-scope="{ ok, cancel }")
      button.btn.modal-ok-btn(v-if="checked" type="button" @click="ok()") OK
      button.btn.modal-ok-btn.disable(v-else type="button" disabled) OK
      button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { ReservationTableItem } from "@/pc/containers/reservations/ReservationTable.vue";

/**
 * 案内転送確認モーダル
 */
@Component
export default class TransferOnlineReservationModal extends Vue {
  /** 更新対象 */
  @Prop()
  value!: any;
  /** 転送元の予約 */
  @Prop()
  reservation!: ReservationTableItem;

  /** 更新対象 */
  public checked: boolean = false;

  get _residentRoom(): string {
    if (!this.reservation) {
      return "";
    }
    return this.reservation.resident ? this.reservation.resident.room : "";
  }
  get _residentName(): string {
    if (!this.reservation) {
      return "";
    }
    return this.reservation.resident ? this.reservation.resident.name : "";
  }
  get _familyName(): string {
    if (!this.reservation) {
      return "";
    }
    return this.reservation.family ? this.reservation.family.name : "";
  }
  get _familyRelation(): string {
    if (!this.reservation) {
      return "";
    }
    return this.reservation.family ? this.reservation.family.relation : "";
  }

  /**
   * モーダル表示
   */
  public show(): void {
    const modal: any = this.$refs.modal;
    this.checked = false;
    if (modal) {
      modal.show();
    }

    return;
  }

  /**
   * OKボタン押下イベント
   */
  private update(): void {
    this.$emit("register");

    return;
  }

  /**
   * キャンセルボタン押下イベント
   */
  private cancel(): void {
    this.$emit("cancel");

    return;
  }
}
</script>
